// @tenorlab/nuxt-dashboard-pro
// file: app/components/sidebar/menu-items-container/use-computed-props.ts
import { computed } from 'vue'
import { getDistinctCssClasses } from '@tenorlab/vue-dashboard/core'
import type { INavigationItem } from '@/models'
import type { TMenuItemContainerProps } from './models'

// const _getSelectedCss = (selected: boolean) => {
//   return selected
//     ? 'content-primary-invert hover:brightness-110'
//     : 'content-sidebar hover:border-primary hover:content-primary-invert'
// }
const _getSelectedCss = (selected: boolean) => {
  return selected
    ? 'border border-primary content-primary-invert hover:brightness-110'
    : 'border border-transparent content-sidebar hover:border-primary hover:content-primary-invert'
}

export const useComputedProps = (props: TMenuItemContainerProps) => {
  const hasChildren = computed(() => {
    return (props.model?.children || []).length > 0
  })

  const iconCss = computed(() => {
    const result = ['flex-shrink-0 size-4']

    if (props.model.selected) {
      result.push('content-primary-invert')
    } else {
      if (props.model.badgeValue && !props.model.isExpanded) {
        // colro the icon
        result.push(`text-${props.model.badgeCategory || 'warning'}`)
      } else {
        result.push('content-sidebar group-hover:content-primary-invert group-hover:brightness-110')
      }
    }

    return getDistinctCssClasses('', ...result)
  })

  const badgeValueCss = computed(() => {
    return getDistinctCssClasses(
      'flex items-center w-fit px-1',
      'size-4 text-xs text-center rounded-full',
      `bg-${props.model.badgeCategory} content-${props.model.badgeCategory}`,
    )
  })

  const menuItemCssClass = computed(() => {
    return [
      'group cursor-pointer',
      'flex items-center justify-between',
      'w-full gap-3 py-2 px-2 text-left text-sm font-medium rounded-xs',
      _getSelectedCss(props.model.selected),
    ]
      .join(' ')
      .trim()
  })

  const cssClassExpandedIndicator = computed(() => {
    const results = [
      'ml-3 h-5 w-5 flex-shrink-0 transform transition-colors duration-150 ease-in-out',
      'content-sidebar group-hover:content-primary-invert group-hover:brightness-110',
    ]
    if (!props.model.isExpanded) {
      results.push('')
    } else {
      results.push('rotate-90')
    }
    return results.join(' ').trim()
  })

  const childButtonCssClass = (childItem: INavigationItem) => {
    const selected = childItem.selected
    const { isCollapsed } = props
    return [
      'cursor-pointer group',
      'flex flex-row items-center gap-2 w-full px-2 py-1',
      isCollapsed ? 'justify-center' : '',
      'text-sm font-medium rounded-xs',
      _getSelectedCss(selected),
    ]
      .join(' ')
      .trim()
  }

  return {
    hasChildren,
    iconCss,
    badgeValueCss,
    menuItemCssClass,
    cssClassExpandedIndicator,
    childButtonCssClass,
  }
}
